"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagStatusPropertyOption = exports.isTagStatusProperty = exports.tagStatusPropertyDefinition = void 0;
const tagStatusPropertyOptions = [
    'active',
    'inactive',
    'deleted',
];
exports.tagStatusPropertyDefinition = {
    view: { label: 'Status' },
    constraints: [
        {
            name: 'options',
            argument: tagStatusPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'tag-status',
};
const isTagStatusProperty = (prop) => {
    return prop.name === exports.tagStatusPropertyDefinition.name;
};
exports.isTagStatusProperty = isTagStatusProperty;
const isTagStatusPropertyOption = (option) => {
    return tagStatusPropertyOptions.includes(option);
};
exports.isTagStatusPropertyOption = isTagStatusPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXN0YXR1cy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RhZy1zdGF0dXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSx3QkFBd0IsR0FBRztJQUMvQixRQUFRO0lBQ1IsVUFBVTtJQUNWLFNBQVM7Q0FDRCxDQUFBO0FBRUcsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0lBQ3pCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsd0JBQXdCO1NBQ25DO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsUUFBUTtJQUNkLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxJQUFrQixFQUE2QixFQUFFO0lBQ25GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CO0FBSU0sTUFBTSx5QkFBeUIsR0FBRyxDQUFDLE1BQWMsRUFBcUMsRUFBRTtJQUM3RixPQUFRLHdCQUE4QyxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUN6RSxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==